import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { menuData, GOOGLE_PLAY_LINK } from "../../pages/Home/constants";
import "./index.scss";

interface HeaderProps {
  variant?: "light" | "dark"; // light: 白色文字（用于首页），dark: 深色文字（用于其他页面）
}

const Header: React.FC<HeaderProps> = ({ variant = "dark" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const activeKey = location.pathname;

  const onChange = (path: string) => {
    if (path === "/google-play") {
      window.location.href = GOOGLE_PLAY_LINK;
      return;
    }
    navigate(path);
  };

  return (
    <div className={`header ${variant === "light" ? "header-light" : "header-dark"}`}>
      <div className="logo" />
      <div className="title" style={{ color: variant === "light" ? "#ffffff" : "#333333" }}>Pitage</div>
      <div className="menu">
        {menuData.map((item) => (
          <div
            key={item.key}
            className={`menu-item${
              item.key === activeKey ? " active" : ""
            }`}
            onClick={() => onChange(item.key)}
          >
            {item.title}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Header;

